import { render, staticRenderFns } from "./XhImageItem.vue?vue&type=template&id=13d71692&scoped=true&"
import script from "./XhImageItem.vue?vue&type=script&lang=js&"
export * from "./XhImageItem.vue?vue&type=script&lang=js&"
import style0 from "./XhImageItem.vue?vue&type=style&index=0&id=13d71692&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13d71692",
  null
  
)

export default component.exports